<template>
  <div class="animated fadeIn requirements--requirements-list d-flex flex-column">
    <b-tabs fill active-nav-item-class="font-weight-bold text-uppercase" v-model="tabIndex">
      <b-tab title="Requirements" href="#reqTab">
        <fixed-header title="Requirements" :records="pageInfo.totalItems" hideBackBtn>
          <div class="buttons-panel m-0">
            <!-- <bom-import @refreshGrid="getAll({})" />
            <b-button size="sm" variant="primary" @click="$bvModal.show('import-bom-modal')">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>Import BOM
            </b-button> -->
            <b-button v-if="checkClaim(CAN_ADD_REQUIREMENTS)" @click="redirectToAdd" size="sm" variant="primary">
              <i class="fa fa-plus" aria-hidden="true"></i>
              Add Req
            </b-button>
            <add-record
                v-if="checkClaim(CAN_ADD_QUOTES)"
                :title="'Add to Quote'"
                :fields="quoteFields"
                :gridId="quotesAddGrid"
                :resetModal="resetModal"
                :saveRecord="createQuote"
                :items="quotesData"
                :isDisabledAdd="isDisableAddToQuote"
                @selectedInvoice="onSelectedQuoteItem"
                :footerTerm="'Quote'"
                :disabledLeftBtn="false"
                :disabledRightBtn="quotesData.length == 0 || selectedQuoteItem == 0"
                showLeftFooterBtn
                hideActionBtn
                ref="add-requirement-to-quote"
                class="mr-2">
              <template v-slot:subHeader>
                <b-row>
                  <b-col cols="2">
                    <dt>Customer</dt>
                    <dd>{{ selectedRequirement.companyName }}</dd>
                  </b-col>
                  <b-col cols="2">
                    <dt>Contact</dt>
                    <dd>{{ selectedRequirement.contactFullName }}</dd>
                  </b-col>
                  <b-col cols="2">
                    <dt>Sales Person</dt>
                    <dd>{{ selectedRequirement.salesPersonUserFullName }}</dd>
                  </b-col>
                </b-row>
                <div class="mt-2">
                  <h6>To add the selected requirement, select a pending or open quote, or create a new quote</h6>
                  <b-row>
                    <b-col cols="2">
                      <b-form-checkbox v-model="quotesShow.showPending"> Show Pending </b-form-checkbox>
                    </b-col>
                    <b-col cols="2">
                      <b-form-checkbox v-model="quotesShow.showOpen"> Show Open </b-form-checkbox>
                    </b-col>
                  </b-row>
                </div>
              </template>
            </add-record>
            <b-button v-b-modal.selectedRequirementsModal size="sm" variant="primary"
              :disabled="!selectedRequirementsCount">Selected ({{selectedRequirementsCount}})
            </b-button>
            <b-modal id="selectedRequirementsModal" @ok="onCreateUltraRfp" title="Selected parts for Ultra RFP" size="xl">
              <grid-component
                  isResizable
                  isReorderable
                  :gridId="gridId"
                  :itemData="checkedRowItemIdsObjArr"
                  :fields="fields"
                  :sortMethod="sortGrid"
                  :onEdit="openEdit"
                  :onDelete="onDelete"
                  :navigationField="'partNumber'"
                  @getData="onGetData"
                />
              <template slot="modal-footer" slot-scope="{ ok }">
                <b-button size="sm" variant="primary" :disabled="!selectedRequirementsCount || isSaving" @click="ok">
                  <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Send to Sourcing
                </b-button>
              </template>
            </b-modal>
            <b-button v-if="checkClaim(CAN_ADD_SOURCING_CENTER)" v-b-modal="'create-ultra-rfp-modal'" size="sm" variant="primary" :disabled="!selectedRequirementsCount">
              <i class="fa fa-plus-circle" aria-hidden="true"></i>
              Send to Sourcing
            </b-button>
            <button type="button" @click="getRequirementsExcel()" class="btn btn-secondary btn-sm d-inline mr-3">
              <i class="fa fa-download"></i>
            </button>
            <b-modal id="create-ultra-rfp-modal" ref="create-ultra-rfp-modal" size="lg" title="Send to Sourcing">
              <create-ultra-rfp-modal :onRowClick="onRowClick" :checkedRowItemIdsObjArr="checkedRowItemIdsObjArr" />
              <template slot="modal-footer">
                  <b-button variant="primary" @click="onCreateUltraRfp()" class="mr-auto" :disabled="isCreatingRfp"> 
                    <i v-if="isCreatingRfp" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                    Send to Sourcing
                  </b-button>
                  <b-button @click="$bvModal.hide('create-ultra-rfp-modal')">Cancel</b-button>
                  <b-button variant="primary" @click="onAddAsRfpLines()" :disabled="selectedRFP == 0 || isLoading">
                    <i v-if="isLoading" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Add to Sourcing</b-button>
              </template>
            </b-modal>
            <!-- <grid-settings :gridId="gridId" :fields="fields" /> -->
          </div>

        </fixed-header>
        <div class="card">
          <div class="card-body d-flex flex-column">
            <div class="d-flex justify-content-start mb-2">
                <b-form-group label="Status" class="mr-2">
                  <b-form-select v-model="filterObj.statusId" @change="onSearch">
                    <option :value="null">All</option>
                    <option v-for="(status) in sortSelect(crfqLineStatuses)" :key="status.id" :value="status.id">{{status.name}}
                    </option>
                  </b-form-select>
                </b-form-group>
                <b-form-group label="Part Number" class="mr-2">
                  <b-form-input v-model="filterObj.partNumber" size="sm" type="text" id="part-number-filter"
                    @input="onSearch"></b-form-input>
                </b-form-group>
                <b-form-group label="Customer RFQ Number" class="mr-2">
                  <b-form-input v-model="filterObj.customerRfqNumber" size="sm" type="text"
                    id="customer-rfq-number-filter" @input="onSearch"></b-form-input>
                </b-form-group>
                <b-form-group label="Customer Part Number" class="mr-2">
                  <b-form-input v-model="filterObj.customerPartNumber" size="sm" type="text"
                    id="customer-part-number-filter" @input="onSearch"></b-form-input>
                </b-form-group>
                <b-form-group label="Customer" class="mr-2">
                  <b-form-input v-model="filterObj.customer" size="sm" type="text" id="customer-filter" @input="onSearch">
                  </b-form-input>
                </b-form-group>
                <b-form-group label="Sales Rep" class="mr-2" v-if="checkClaim(CAN_VIEW_ALL_REQUIREMENTS)">
                  <!-- <b-form-input v-model="filterObj.salesRep" @input="onSearch" size="sm" /> -->
                  <b-form-select v-model="filterObj.salesPersonUserId" @change="onSearch">
                    <option :value="null">All</option>
                    <option
                      v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                      :key="indexRep"
                      :value="selectRep.id"
                    >{{ selectRep.name }}</option>
                  </b-form-select>
                </b-form-group>
                <date-range-picker :dateFrom="filterObj.dateFrom" :dateTo="filterObj.dateTo" @handleSearch="onSearch"></date-range-picker>
                <!--<date-range-picker ref="dateRangePicker" :handleSearch="search"></date-range-picker>-->
                <div class="clear-filter-button-container">
                  <b-button size="sm" @click="clearFilter">Clear filters</b-button>
                </div>
            </div>
            <grid-component
              isResizable
              isReorderable
              isSortable
              :canEdit="checkClaim(CAN_EDIT_REQUIREMENTS)"
              :canDelete="checkClaim(CAN_DELETE_REQUIREMENTS)"
              :gridId="gridId"
              :pageable="pageable"
              :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
              :take="pageInfo.pageSize"
              :itemData="itemData"
              :pageSizes="pageInfo.pageSize"
              :totalItems="pageInfo.totalItems"
              :fields="fields"
              :sortBy="pageInfo.sortBy"
              :sortOrder="pageInfo.sortOrder"
              :sortMethod="sortGrid"
              :checkBoxValues="checkedRowItemIdsArr"
              :onEdit="openEdit"
              :onDelete="onDelete"
              :handleRowClick="handleRowClick"
              :navigationField="'partNumber'"
              :styleCustom="'height: 275px'"
              @getData="onGetData"
              @checkedItem="checkedRowItemIdsArr=$event"
              :isTblLoader="tblLoader"
            />
          </div>
        </div>
        <b-card>
          <tabs :reqLineId="selectedRequirement.id" :partId="selectedRequirement.partId" />
        </b-card>
      </b-tab>
      <b-tab title="BOM" href="#bomTab">
        <b-o-m @onClickBOM="onFilterBOM" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';

import { date } from '@/shared/filters';
import { SEARCH_DEBOUNCE_TIME, GRID_ID, GRID_PAGE_SIZES, SAVE_SETTINGS_DELAY, DATE_FORMAT } from '@/shared/constants';
import DateFilters from '@/shared/components/DateFilters';
import GridSettings from '@/shared/components/GridSettings';
import FixedHeader from '@/shared/components/FixedHeader/indexNew';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
import AddRecord from '@/shared/components/AddRecord';
import CreateUltraRfpModal from './components/CreateUltraRFP';
import GridComponent from '@/shared/components/GridComponent';
import Tabs from './components/Tabs'; //The lower tabs
import quoteFields from '../Quotes/fields';
import defaultFields from './fields';
import BomImport from './components/AddRequirement/components/BOM';
import PreferredSources from '@/shared/components/Sources';
import BOM from './components/BOM/index';

export default {
  components: {
    Tabs,
    DateFilters,
    GridSettings,
    FixedHeader,
    DateRangePicker,
    AddRecord,
    CreateUltraRfpModal,
    GridComponent,
    BomImport,
    PreferredSources,
    BOM
  },
  metaInfo: () => ({
    title: 'Requirements',
  }),
  data() {
    return {
      fields: defaultFields,
      date,
      gridId: GRID_ID.REQUIREMENT,
      pageable: {
        pageSizes: GRID_PAGE_SIZES,
      },
      selectedRowItemId: 0,
      checkedRowItemIdsArr: [],
      quoteFields: quoteFields,
      checkedQuoteItemIds: [],
      reqQuotes: [],
      selectedRFP: 0,
      quotesShow: {
        showPending: true,
        showOpen: true,
      },
      quoteItems: [],
      selectedQuoteItem: 0,
      checkedRowItemIdsObjArr: [],
      quotesAddGrid: GRID_ID.QUOTES,
      isSaving:false,
      isLoading:false,
      isCreatingRfp: false,
      filterPageName: 'requirementsPage',
      lineSourceSelected: [],
      sourceSelectionGridId: GRID_ID.REQUIREMENT_LINE_SOURCE_SELECTION,
      tabIndex: 0,
      tabs: ['#reqTab', '#bomTab']
    }
  },
  computed: {
    // ...mapState('requirements', ['lastOpenedId','sourcesList','checkedRowItemIds']),
    ...mapGetters('requirements', [
      'gridList',
      'selectedRequirement',
      'pageInfo',
      'filters',
      'tblLoader',
      'lastOpenedId',
      'sourcesList',
      'checkedRowItemIds'
    ]), 
    ...mapState('salesReps', ['salesReps']),
    ...mapGetters('lookup', ['crfqLineStatuses']),
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('quotes', ['openQuotesByCompanyIdAndSalesRep']),
    ...mapState('account', ['user']),

    /*Map store filter data with variable to set into filter form*/
    filterObj() {
      return this.filters[this.filterPageName] || {}
    },

    selectedRequirementsCount: function () {
      return this.checkedRowItemIds.length;
    },
    itemData() {
      if (this.gridList == undefined || !this.gridList.length) return [];
      return this.gridList.map((requirement) => ({ ...requirement, selected: requirement.id === this.selectedRowItemId }));
    },
    isDisableAddToQuote() {
      return this.selectedRowItemId == 0 || this.sourcesList.filter(x => x.requirementLineId == this.selectedRowItemId && x.isPreferred).length == 0;
    },
    quotesData() {
      return this.quoteItems.map(quotes => ({ ...quotes, selected: quotes.id == this.selectedQuoteItem}));
    },
  },
  methods: {
    // ...mapMutations('requirements', [
    //      'setItem',
    //   'setCheckedRowItemIdsObjArr',
    //   'setFilters',
    // ]),
    ...mapMutations('requirements', ['setItem']),
    ...mapActions('requirements', [
      'getAll',
      'sortGrid',
      'search',
      'clearSelectedRequirement',
      'createUltraRfp',
      'showDetails',
      'getRequirementsExcel',
      'deleteRequirementLine',
    ]),
    ...mapActions('account', ['saveGridSettings']),
    ...mapActions('quotes', ['getOpenQuotesByCompanyIdAndSalesRep', 'addFromRequirement']),
    ...mapActions('rfps', ['getPendingRfpsBySalesPerson']),
    ...mapActions('rfpDetails', ['addAsRfpLines']),
    ...mapActions('salesReps', ['getSalesReps']),
    // ...mapMutations('quotes', ['setOpenQuotes']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    redirectToAdd() {
      this.$router.push({
        name: 'requirements.add.new',
      });
    },
    openEdit(row) {
      console.log('openEdit: ', row);
        this.setItem({ resource:'lastOpenedId', payload: row.id });

      this.showDetails(row.id);

      this.$router.push({
        name: 'requirements.crfq',
        query: { crfqId: row.requirementId, crfqLineId: row.id, partId: row.partId },
      });
    },
    async onDelete({ id, requirementId }) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete requirement line?  This action cannot be undone.`});
      if (deleteConfirmed) {
        //await this.deleteCrfqPart(part.id);
        await this.deleteRequirementLine({ id, requirementId });
        //Get the data
        this.getAll({});
      }
    },
    async onGetData(params) {
      await this.getAll(params);
    },
      onSearch: debounce(function(data = false) {
          if(typeof data === 'object') { Object.assign(this.filterObj,data) }
          this.search({'filters':this.filterObj, page:this.filterPageName});
      }, SEARCH_DEBOUNCE_TIME),

      clearFilter(callSearch = true) {
          this.clearObject(this.filterObj);
          this.checkedRowItemIdsArr = [];
          if (callSearch) {
            this.search({'filters':this.filterObj,page:this.filterPageName});
          }
      },

    async onCreateUltraRfp() {
      try {
        this.isCreatingRfp = true;
        const result = await this.createUltraRfp(this.checkedRowItemIds);
        this.isCreatingRfp = false;
        this.$router.push({
          name: 'rfp.details',
          params: {id: result.key},
        });

        this.clearSelectedRequirement();
      }catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }

      return;
    },
    handleRowClick(row) {
        this.setItem({ resource:'lastOpenedId', payload: row.dataItem.id });
      this.selectedRowItemId = row.dataItem.id;
      this.showDetails(this.selectedRowItemId);
    },
    onSetCheckedRowItemIdsObjArr() {
      this.checkedRowItemIdsObjArr = this.itemData.filter((item) => {
        return this.checkedRowItemIdsArr.some((id) => {
          return id == item.id;
        })
      }).map(items => {
        delete items.selected;
        return items;
      });
    },
    async createQuote(isNewQuote) {
      this.$refs['add-requirement-to-quote'].hideModal();
      
      this.$snotify.info('Adding Requirement to Quote', 'Quote');

      const quote = await this.addFromRequirement({
        quoteId: isNewQuote ? 0 : this.selectedQuoteItem,
        requirementLineId: this.selectedRowItemId
      });

      if (quote.status == 200)
        this.$snotify.success('Successfully added Requirement to Quote', 'Quote');
      else
        this.$snotify.error('Error adding Requirement to Quote', 'Quote');

      if (quote.data.quoteId > 0) {
        this.$router.push({
          name: 'quotes.edit',
          params: { id: quote.data.quoteId },
        });
      }
    },
    resetModal() {},
    async getOpenQuotes(data) {
      await this.getOpenQuotesByCompanyIdAndSalesRep(data).then(() => {
        this.quotesShow.showPending = this.quotesShow.showOpen = true;
        this.initializeQuoteItems();
      }) ;
    },
    onRowClick(e) {
      this.selectedRFP = e.dataItem.id;
    },
    async onAddAsRfpLines() {
      try {
        this.isLoading = true;
        await this.addAsRfpLines({
          requirements: this.checkedRowItemIdsObjArr,
          selectedRFP: this.selectedRFP,
          salesPersonId: this.user.id,
        }).then(() => {
          this.clearSelectedRequirement();
          this.isSaving = false;
          this.$router.push({
            name: 'rfp.details',
            params: { id: this.selectedRFP },
          });
        });
      } catch {}
      this.isSaving = false;
    },
    initializeQuoteItems() {
      this.quoteItems = [];
      this.selectedQuoteItem = 0;

      for(let i = 0; i < this.openQuotesByCompanyIdAndSalesRep.length; i++) {
        if (this.quotesShow.showPending && this.openQuotesByCompanyIdAndSalesRep[i].statusName === 'Pending')
          this.quoteItems.push(this.openQuotesByCompanyIdAndSalesRep[i]);
        if (this.quotesShow.showOpen && this.openQuotesByCompanyIdAndSalesRep[i].statusName === 'Open')
          this.quoteItems.push(this.openQuotesByCompanyIdAndSalesRep[i]);
      }
    },
    onSelectedQuoteItem($event) {
      this.selectedQuoteItem = $event;
    },
    onFilterBOM(e) {
      this.clearFilter(false);
      this.filterObj.requirementId = e.id;
      this.filterObj.customerRfqNumber = e.rfqNum;
      this.onSearch();      
      this.tabIndex = 0;
    }
  },
  watch: {
    selectedRowItemId() {
      if (this.selectedRowItemId > 0 && Object.keys(this.selectedRequirement).length > 0) {
        this.getOpenQuotes({companyId: this.selectedRequirement.companyId, salesRep: this.selectedRequirement.salesPersonUserId});
      }
    },
    gridList() {
        this.setItem({ resource:'selectedRequirement', payload: {}});
        //This function sets the first row as the selected row
        this.selectedRowItemId = this.setSelectedRowId(this.gridList,this.selectedRowItemId,this.lastOpenedId);
        if (this.gridList.length > 0) { this.showDetails(this.selectedRowItemId); }
    },
    checkedRowItemIdsArr() {
      this.onSetCheckedRowItemIdsObjArr();
      this.setItem({ resource:'checkedRowItemIds', payload: this.checkedRowItemIdsArr});
    },
    quotesShow: {
      handler() {
        this.initializeQuoteItems();
      },
      deep: true,
    },
  },
  mounted() {
      //Prevent account id from being from other requirements grid
      /*when page load set page name in filter page so it will be used in search function*/
      this.setItem({ resource:'filterPage', payload: this.filterPageName });
      this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
      this.getAll({});

      //this.checkedRowItemIdsArr = [...this.checkedRowItemIds];

      this.getPendingRfpsBySalesPerson(this.user.id);
      if (this.salesReps.length == 0) {
        this.getSalesReps();
      }
  },
  beforeDestroy() {
    this.setItem({ resource:'checkedRowItemIds', payload: []});
    this.checkedRowItemIdsObjArr = [];
  },
};
</script>

<style lang="scss">
  .requirements {
    &--requirements-list {
      .buttons-panel {
        text-align: right;
        margin-top: 7px;
        .btn {
          margin-left: 5px;
        }
      }
    }
  }
</style>
